module.exports = __webpack_public_path__ + "img/selected5-min.3d3fc80c.png";